// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (-webkit-min-device-pixel-ratio:0){input[data-v-1a00d2fc],select[data-v-1a00d2fc],textarea[data-v-1a00d2fc]{font-size:16px}}.know_btn[data-v-1a00d2fc]{text-align:center}.buttonKnow[data-v-1a00d2fc]{background-color:#fb9013;color:#fff;font-size:15px;margin-left:44%}@media only screen and (max-width:600px){.cont6 button[data-v-1a00d2fc]{font-size:23px;margin-bottom:20px;margin-left:104px}.m_resp[data-v-1a00d2fc]{font-size:3rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
